import { useParams } from "react-router";

const useOrgRoute = () => {
  const { orgId } = useParams();

  return {
    isOrgRoute: !!orgId,
    orgId,
  };
};

export default useOrgRoute;
